<template>
  <card>
    <div class="p-text-card">
      <div
        v-if="hasImage"
        class="p-text-card__aside"
      >
        <div
          class="p-text-card__image"
          data-test-id="text-card.image"
        >
          <img
            :src="imageSrc"
            alt=""
          >
        </div>
      </div>
      <div class="p-text-card__content">
        <div class="p-text-card__title">
          <div
            class="el-text el-text--paragraph-accent el-text--ellipsis"
            data-test-id="text-card.title"
          >
            {{ title }}
          </div>
        </div>
        <div
          class="p-text-card__text el-text el-text--body-24"
          data-test-id="text-card.text"
        >
          {{ text }}
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from '@/app/components/Card';
import { getImgSrc } from '@/app/library/getImgSrc';

export default {
  name: 'TextCard',
  components: {
    Card
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasImage() {
      return !!this.image;
    },
    imageSrc() {
      return getImgSrc(this.image);
    }
  }
};
</script>

<style lang="scss" scoped>
.p-text-card {
  display: flex;
  padding: 24px;

  &__aside {
    display: flex;
    align-items: center;
    margin-right: 24px;
  }

  &__image {
    width: 80px;

    img {
      max-width: 100%;
    }
  }

  &__content {

  }

  &__title {

  }

  &__text {
    margin-top: 8px;
  }
}
</style>
